import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        minWidth: "37ch",
        marginTop: theme.spacing(5),
      },
    },
    paper: {
      padding: theme.spacing(2),
      margin: theme.spacing(3),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    btn: {
      marginTop: theme.spacing(2),
    },
    subtitle: {
      marginTop: "3.5%",
      marginBottom: "-1.5%",
      color: "black",
    },
  })
);
export default useStyles;
